/* ============================================================
   Maison Atelier Premium — cart-drawer.js
   Carrello AJAX (Section Rendering API) + quick add
   ============================================================ */
(function () {
  'use strict';
  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};
  var SECTION = 'cart-drawer';

  var drawer = document.querySelector('[data-cart-drawer]');
  var loader = document.querySelector('[data-cart-loader]');
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var mutationQueue = Promise.resolve();
  var loaderTimer;

  function setLoader(on) {
    if (!loader) return;
    clearTimeout(loaderTimer);
    if (on) { loader.hidden = false; requestAnimationFrame(function () { loader.classList.add('is-active'); }); }
    else { loader.classList.remove('is-active'); loaderTimer = setTimeout(function () { loader.hidden = true; }, 200); }
    loader.setAttribute('aria-hidden', String(!on));
  }

  function openCart() {
    if (drawer && window.theme.openPanel) window.theme.openPanel(drawer, 'is-open');
    loadCartRecommendations();
  }

  function postJSON(url, body) {
    var multipart = body instanceof FormData;
    return fetch(url.replace(/\.js$/, '') + '.js', {
      method: 'POST',
      headers: multipart ? { 'Accept': 'application/json' } : { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: multipart ? body : JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status >= 400) {
          throw new Error(typeof data.description === 'string' ? data.description : (strings.cartError || 'Impossibile aggiornare il carrello. Riprova.'));
        }
        return data;
      });
    });
  }

  function showError(container, error) {
    if (!container) return;
    var message = container.querySelector('[data-cart-error]');
    if (!message) {
      message = document.createElement('p');
      message.setAttribute('data-cart-error', '');
      message.setAttribute('role', 'alert');
      container.appendChild(message);
    }
    message.textContent = error ? (error.message || strings.cartError || 'Impossibile aggiornare il carrello. Riprova.') : '';
    message.hidden = !error;
  }

  function renderSections(sections) {
    if (!sections || !sections[SECTION]) return false;
    var parsed = new DOMParser().parseFromString(sections[SECTION], 'text/html');
    var newContent = parsed.querySelector('[data-cart-drawer-content]');
    var oldContent = document.querySelector('[data-cart-drawer-content]');
    if (!newContent || !oldContent) return false;
    oldContent.innerHTML = newContent.innerHTML;

    var newFooter = parsed.querySelector('[data-cart-footer]');
    var oldFooter = document.querySelector('[data-cart-footer]');
    if (oldFooter) oldFooter.remove();
    if (newFooter && drawer) drawer.appendChild(newFooter);

    // aggiorna contatori
    var count = parsed.querySelector('[data-cart-count]');
    var n = count ? parseInt(count.textContent, 10) || 0 : 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: { item_count: n } } }));
    loadCartRecommendations();
    document.dispatchEvent(new CustomEvent('cards:rendered', { detail: { root: drawer } }));
    return true;
  }

  function mutate(url, body) {
    if (body instanceof FormData) {
      body.set('sections', SECTION);
      body.set('sections_url', window.location.pathname);
    } else {
      body.sections = [SECTION];
      body.sections_url = window.location.pathname;
    }
    var request = mutationQueue.then(function () { return postJSON(url, body); }).then(function (data) {
      if (!renderSections(data.sections)) window.location.assign(routes.cart || rootUrl + 'cart');
      return data;
    });
    mutationQueue = request.catch(function () {});
    return request;
  }

  function loadCartRecommendations() {
    var holder = document.querySelector('[data-cart-related]');
    if (!holder || holder.hidden) return;

    var productId = holder.getAttribute('data-product-id');
    var target = holder.querySelector('[data-cart-related-target]');
    var endpoint = holder.getAttribute('data-url') || routes.recommendations || '/recommendations/products';
    var sectionId = holder.getAttribute('data-section-id') || SECTION;
    var limit = holder.getAttribute('data-limit') || '4';
    var intent = holder.getAttribute('data-intent') || 'related';
    if (!productId || !target || !endpoint) return;

    var requestKey = [productId, sectionId, limit, intent].join(':');
    if (holder.getAttribute('data-loaded-key') === requestKey) return;
    holder.setAttribute('data-loaded-key', requestKey);
    holder.classList.add('is-loading');

    var url = endpoint +
      '?section_id=' + encodeURIComponent(sectionId) +
      '&product_id=' + encodeURIComponent(productId) +
      '&limit=' + encodeURIComponent(limit) +
      '&intent=' + encodeURIComponent(intent);

    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) {
        if (!r.ok) throw new Error('Recommendations unavailable');
        return r.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-related-target]');
        if (!fresh) return;

        var nextHtml = fresh.innerHTML.trim();
        if (!nextHtml) {
          holder.hidden = true;
          return;
        }

        target.innerHTML = fresh.innerHTML;
        holder.hidden = false;
        document.dispatchEvent(new CustomEvent('cards:rendered', { detail: { root: target } }));
      })
      .catch(function () {
        if (!target.innerHTML.trim()) holder.hidden = true;
      })
      .finally(function () {
        holder.classList.remove('is-loading');
      });
  }

  /* ---------- Add to cart (form prodotto + quick add singolo) ---------- */
  function addFromForm(form) {
    var btn = form.querySelector('[type="submit"]');
    if (form.getAttribute('aria-busy') === 'true' || (btn && btn.disabled)) return Promise.resolve();
    var formData = new FormData(form);
    var quantity = Number(formData.get('quantity') || '1');
    if (!formData.get('id') || !Number.isInteger(quantity) || quantity < 1) {
      showError(form, new Error(strings.selectVariant || 'Seleziona una variante e una quantità valida.'));
      return Promise.resolve();
    }
    form.setAttribute('aria-busy', 'true');
    showError(form, null);
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    setLoader(true);
    return mutate(routes.cartAdd || rootUrl + 'cart/add', formData)
      .then(function () { openCart(); })
      .catch(function (error) { showError(form, error); })
      .finally(function () {
        setLoader(false);
        form.removeAttribute('aria-busy');
        if (btn) {
          btn.classList.remove('is-loading');
          btn.disabled = btn.getAttribute('data-variant-unavailable') === 'true';
        }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form], [data-quick-add-form], form.product-form');
    if (!form) return;
    e.preventDefault();
    addFromForm(form);
  });

  /* ---------- Quantità / rimozione ---------- */
  function changeLine(key, quantity) {
    if (!key || !Number.isInteger(quantity) || quantity < 0) return;
    showError(drawer, null);
    return mutate(routes.cartChange || rootUrl + 'cart/change', { id: key, quantity: quantity })
      .catch(function (error) { showError(drawer, error); });
  }
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    if (input.value.trim() === '') return;
    changeLine(input.getAttribute('data-key'), Number(input.value));
  });
  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); changeLine(remove.getAttribute('data-key'), 0); }
  });

  /* ---------- Gift wrap + note ---------- */
  document.addEventListener('change', function (e) {
    var gift = e.target.closest('[data-gift-wrap]');
    if (!gift) return;
    mutate(routes.cartUpdate || rootUrl + 'cart/update', { attributes: { 'Confezione regalo': gift.checked ? 'Sì' : '' } })
      .catch(function (error) { gift.checked = !gift.checked; showError(drawer, error); });
  });
  var noteTimer;
  var pendingNote = null;
  var noteRequest = null;
  function saveNote() {
    clearTimeout(noteTimer);
    if (pendingNote === null) return noteRequest || Promise.resolve();
    var val = pendingNote;
    pendingNote = null;
    var request = mutationQueue.then(function () { return postJSON(routes.cartUpdate || rootUrl + 'cart/update', { note: val }); });
    mutationQueue = request.catch(function (error) { showError(drawer, error); });
    noteRequest = request;
    request.then(function () { if (noteRequest === request) noteRequest = null; }, function () { if (noteRequest === request) noteRequest = null; });
    return request;
  }
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    pendingNote = note.value;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { saveNote().catch(function () {}); }, 600);
  });
  document.addEventListener('click', function (event) {
    var checkout = event.target.closest('[data-cart-checkout]');
    if (!checkout || (pendingNote === null && !noteRequest)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkout.getAttribute('aria-busy') === 'true') return;
    checkout.setAttribute('aria-busy', 'true');
    saveNote().then(function () { window.location.assign(checkout.href); })
      .catch(function () { checkout.removeAttribute('aria-busy'); });
  }, true);

  /* ---------- Quick add multivariante (mini drawer) ---------- */
  var qaDrawer = document.querySelector('[data-quick-add-drawer]');
  var quickAddRequest = 0;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn || !qaDrawer || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-quick-add');
    var requestId = ++quickAddRequest;
    btn.classList.add('is-loading');
    fetch(rootUrl + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { if (!r.ok) throw new Error(strings.cartError); return r.json(); })
      .then(function (product) {
        if (requestId !== quickAddRequest) return;
        buildQuickAdd(product);
        if (window.theme.openPanel) window.theme.openPanel(qaDrawer, 'is-open');
      })
      .catch(function (error) { showError(btn.closest('.quick-add'), error); })
      .finally(function () { btn.classList.remove('is-loading'); });
  });

  function buildQuickAdd(product) {
    var title = qaDrawer.querySelector('[data-quick-add-title]');
    var body = qaDrawer.querySelector('[data-quick-add-body]');
    if (title) title.textContent = product.title;
    if (!body) return;
    body.innerHTML = '';
    var choices = document.createElement('div');
    choices.className = 'variant-values';
    choices.setAttribute('role', 'group');
    choices.setAttribute('aria-label', strings.chooseSize || 'Scegli una variante');
    product.variants.forEach(function (v) {
      var soldout = v.available ? '' : ' (' + (strings.soldOut || '') + ')';
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--secondary';
      button.style.minWidth = 'auto';
      button.setAttribute('data-quick-add-variant', v.id);
      button.disabled = !v.available;
      button.textContent = v.title + soldout;
      choices.appendChild(button);
    });
    body.appendChild(choices);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quick-add-variant]');
    if (!button || button.disabled) return;
    event.preventDefault();
    button.disabled = true;
    button.classList.add('is-loading');
    var container = button.closest('[data-quick-add-body], .quick-add');
    showError(container, null);
    setLoader(true);
    mutate(routes.cartAdd || rootUrl + 'cart/add', { items: [{ id: button.getAttribute('data-quick-add-variant'), quantity: 1 }] })
      .then(function () {
        if (qaDrawer && window.theme.closePanel) window.theme.closePanel(qaDrawer);
        openCart();
      })
      .catch(function (error) { showError(container, error); })
      .finally(function () { setLoader(false); button.disabled = false; button.classList.remove('is-loading'); });
  });

  // espone l'add per product-form.js (Buy now / variant change non serve qui)
  window.theme.cart = { add: addFromForm, open: openCart, mutate: mutate };
  loadCartRecommendations();
})();
